import { HotspotWithLabel } from "@nova/constants"
import { createSlice } from "@reduxjs/toolkit"
import { clearSelection, selectSingleLayer } from "panels/content/side-panel/slice.new"
import { closeHotspotPanel } from "panels/hotspot/slice"

const hotspotMultiSelectName = "hotsot-multi-select"

type HotspotMultiSelectMode = "delete"

const initialState = {
    hotspots: [] as HotspotWithLabel[],
    multiRemovalOpen: false,
    infraredFlightId: "",
    mode: undefined as HotspotMultiSelectMode | undefined,
}

const slice = createSlice({
    name: hotspotMultiSelectName,
    initialState,
    reducers: {
        openHotspotMultiRemoval: (state, action: { payload: { infraredFlightIds: string } }) => {
            state.infraredFlightId = action.payload.infraredFlightIds
            state.multiRemovalOpen = true
            state.mode = "delete"
        },
        closeHotspotMultiRemoval: () => {
            return initialState
        },
        setSelectedHotspots: (state, action: { payload: HotspotWithLabel[] }) => {
            state.hotspots = action.payload
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(closeHotspotPanel, () => {
                return initialState
            })
            .addCase(clearSelection, () => {
                return initialState
            })
            .addCase(selectSingleLayer, (state, action) => {
                if (action.payload.id !== state.infraredFlightId) {
                    return initialState
                }
            })
    },
})

export const { openHotspotMultiRemoval, closeHotspotMultiRemoval, setSelectedHotspots } =
    slice.actions
export const HotspotMultiSelectReducer = { [hotspotMultiSelectName]: slice.reducer }
export const HotspotMultiSelectSliceName = hotspotMultiSelectName
